// extracted by mini-css-extract-plugin
module.exports = {"text":"text_text__1Fq9m","noMargin":"text_noMargin__3qwCw","center":"text_center__1Q1Jt"};